import { useTranslation } from 'react-i18next'
import { BetTypeEnum, TwoNumberPatternEnum } from '../../../BetLotto.types'
import { AddLottoListHandler } from '../../PanelSelection.types'

interface TwoNumberPatternProps {
  type: TwoNumberPatternEnum
  activeBetType: BetTypeEnum[]
  addLottoListAndHandleResponse: AddLottoListHandler
}
const TwoNumberPattern = ({
  type,
  activeBetType,
  addLottoListAndHandleResponse,
}: TwoNumberPatternProps) => {
  const { t } = useTranslation()
  const getName = (type: TwoNumberPatternEnum) => {
    switch (type) {
      case TwoNumberPatternEnum.FRONT_RUNNING:
        return t('betDetailPanel.betLottoType.start_number')
      case TwoNumberPatternEnum.END_RUNNING:
        return t('betDetailPanel.betLottoType.end_number')
      case TwoNumberPatternEnum.NINETEEN_NUMBER:
        return t('betDetailPanel.betLottoType.19_number')
    }
  }
  const onSelectBetNumber = (betNumber: string) => {
    addLottoListAndHandleResponse(betNumber, activeBetType, 1, {
      twoNumberPattern: type,
    })
  }
  const isDisabled = activeBetType?.length === 0 || !activeBetType
  return (
    <div>
      <div className="text-[var(--caption-text)] text-sm text-center font-medium mb-2">
        {getName(type)}
      </div>
      <div className="flex gap-1">
        {[...Array(10)].map((_, i) => (
          <button
            type="button"
            key={`${type}-${i}-${activeBetType}`}
            onClick={() => onSelectBetNumber(i.toString())}
            className={`w-8 h-8 flex items-center justify-center rounded-lg border font-medium text-sm transition-all ${
              isDisabled
                ? 'bg-[var(--grid-item-disabled-bg)] text-[var(--grid-item-disabled-text)] border-[var(--grid-item-disabled-border)] cursor-not-allowed'
                : 'bg-[var(--grid-item-bg)] text-[var(--grid-item-text)] border-[var(--grid-item-border)] hover:bg-[var(--grid-item-hover-bg)] hover:text-[var(--grid-item-hover-text)] hover:border-[var(--grid-item-hover-border)]'
            }`}
          >
            {i}
          </button>
        ))}
      </div>
    </div>
  )
}

export default TwoNumberPattern
